import { Annotation, AnnotationBody, AnnotationTarget } from "@annotorious/react";
import { useEffect, useState } from "react";

type DetectionResult = {
  label: string;
  score: number;
  box: number[];
};

const useDetectionToAnnotation = (detectionResults: DetectionResult[]) => {
  const [annotations, setAnnotations] = useState<Annotation[]>([]);
  useEffect(() => {
    const annotationResults: Annotation[] = [];
    detectionResults.map((result, index) => {
      const { label, score, box } = result;
      const annotation_id = `detection-${index}`;
      const geometry = bboxToGeometry(box);
      const body: AnnotationBody = makeAnnotationBody(annotation_id, label, `${score}`);
      const target: AnnotationTarget = {
        "created": new Date(),
        "creator": { "id": "ml_model" },
        "selector": { "type": "RECTANGLE", "geometry": geometry },
        "annotation": annotation_id,
      };
      annotationResults.push({ "id": annotation_id, "bodies": [body], "target": target });
    });
    setAnnotations(annotationResults);
  }, [detectionResults]);

  return annotations;
};

const bboxToGeometry = (box: number[]) => {
  const [x_min, y_min, x_max, y_max] = box;
  return {
    "h": y_max - y_min,
    "w": x_max - x_min,
    "x": x_min,
    "y": y_min,
    "bounds": { "maxX": x_max, "maxY": y_max, "minX": x_min, "minY": y_min },
  };
};

const makeAnnotationBody = (id: string, label: string, value: string) => {
  return {
    "id": label,
    "value": value,
    "purpose": "detection",
    "annotation": id,
  };
};


export default useDetectionToAnnotation;
